import * as yup from 'yup';

export const expenseSchema = yup.object({
  description: yup.string().required('Description is required'),
  amount: yup.number().required('Amount is required').positive('Amount must be positive'),
  categoryId: yup.string().required('Category is required'),
  departmentId: yup.string().nullable(),
  supplierId: yup.string().nullable(),
  status: yup.string().oneOf(['Paid', 'Pending']).default('Paid'),
  dueDate: yup.date().nullable().when('status', {
    is: 'Pending',
    then: () => yup.date().required('Due date is required when status is Pending')
  })
});
